export type DsTextColor =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'
  | 'inverse-primary'
  | 'inverse-secondary'
  | 'inverse-tertiary'
  | 'inverse-quaternary';

export const dsTextColorClassMap: Record<DsTextColor, string> = {
  primary: 'text-ds-text-1',
  secondary: 'text-ds-text-2',
  tertiary: 'text-ds-text-3',
  quaternary: 'text-ds-text-4',
  'inverse-primary': 'text-ds-text-inverse-1',
  'inverse-secondary': 'text-ds-text-inverse-2',
  'inverse-tertiary': 'text-ds-text-inverse-3',
  'inverse-quaternary': 'text-ds-text-inverse-4',
};
